import React, {
    PropTypes,
} from 'react';
import {Link, browserHistory} from 'react-router';
import {connect} from 'react-redux';

const Header = ({onToggle, login, onExit}) => {
    return (
        <header className="header navbar">

            <div className="brand visible-xs">
                {/*toggle offscreen menu*/}
                <div className="toggle-offscreen">
                    <a href="#" className="hamburger-icon visible-xs" onClick={onToggle}>
                        <span/>
                        <span/>
                        <span/>
                    </a>
                </div>
                {/*/toggle offscreen menu*/}

                {/*logo*/}
                <div className="brand-logo" style={{
                    margin: 0,
                    padding: "2px 0",
                }}>
                    <img src="/images/logo_dark.png" height="50" alt="Школа Афіни"/>
                </div>
                {/*/logo*/}

            </div>

            <ul className="nav navbar-nav navbar-right hidden-xs">
                <li>
                    <Link onClick={() => browserHistory.push("/")}>
                        <img src="/images/avatar.jpg" className="header-avatar img-circle ml10" alt="user" title="user"/>
                        <span className="pull-left">{login}</span>
                    </Link>
                </li>
                <li>
                    <Link onClick={onExit}>Вихід</Link>
                </li>
            </ul>
        </header>
    );
};

Header.propTypes = {
    onToggle: PropTypes.func.isRequired,
    onExit: PropTypes.func.isRequired,
    login: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
    return {
        login: state.auth.credentials.login,
    }
}

export default connect(mapStateToProps)(Header);



/** WEBPACK FOOTER **
 ** ./src/modules/layout/Header.js
 **/